import React, { useEffect, useState } from 'react';
import Banners from './banners/banners';
import Classified from './classified/classified';
import Requests from './requests/requests';
import { useDispatch } from "react-redux";

const TAB = {
  BANNER: 1,
  CLASSIFIED: 2,
  REQUESTS: 3,
}

const Ads = () => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(TAB.BANNER);

  useEffect(() => {
    dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Publicidad contratada',
				onBack: null
			}
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main id="affiliate-ads">
      <nav className="tabs">
        <button
          className="tab"
          data-active={String(Boolean(tab === TAB.BANNER))}
          onClick={() => setTab(TAB.BANNER)}
        >
          Banners
        </button>
        <button
          className="tab"
          data-active={String(Boolean(tab === TAB.CLASSIFIED))}
          onClick={() => setTab(TAB.CLASSIFIED)}
        >
          Clasificados
        </button>
        <button
          className="tab"
          data-active={String(Boolean(tab === TAB.REQUESTS))}
          onClick={() => setTab(TAB.REQUESTS)}
        >
          Solicitudes
        </button>
      </nav>

      {tab === TAB.BANNER && (
        <Banners />
      )}

      {tab === TAB.CLASSIFIED && (
        <Classified />
      )}

      {tab === TAB.REQUESTS && (
        <Requests />
      )}
    </main>
  )
}

export default Ads